// 招待费相关接口
import request from '../../request'

// 招待费申请
export function apply(data) {
    return request({
        url: '/office-service/entertainApply/apply',
        data,
        method: "post"
    })
}

// 招待费重新申请
export function reapply(data) {
    return request({
        url: '/office-service/entertainApply/reApply',
        data,
        method: 'post'
    })
}

// 申请详情
export function fetchApplyDetail(data) {
    return request({
        url: `/office-service/entertainApply/query/${data.id}`,
        method: "post"
    })
}

// 招待费台账
export function fetchApplyList(data) {
    return request({
        url: '/office-service/entertainApply/standingBook',
        data,
        method: 'post'
    })
}

// 招待费已审批数据查询
export function queryApprovedEntertain(data) {
    return request({
        url: '/office-service/entertainApply/queryApproved',
        data,
        method: 'post'
    })
}
